import React, {useEffect, useState} from "react";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import axios from "axios";
import {ApiUrl_Login_Logout} from "@utils/Endpoints";
import {JwtUtils} from "@utils/auth/JwtUtils";
import logout = JwtUtils.logout;
import {Link, useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import UserInitialsComponent from "./UserInitialsComponent";
import {usePiwikContext} from "@utils/tracking/PiwikContext";
import styles from "./CurrentUserComponent.module.scss"

export default function CurrentUserComponent() {
    const {rootModel, update} = useAuthenticationContext();
    const {lng} = useParams<{ lng: string }>();
    const {t} = useTranslation();
    const {utils, trackers, events} = usePiwikContext();
    const navigate = useNavigate();

    async function logoutMemberAsync() {
        const userData = {
            id: rootModel?.CurrentUserProfile.Id,
            login: rootModel?.CurrentUserProfile.UserName
        }
        utils.updateUserData(null);
        events.triggerLoginEvent(false, userData.id, userData.login);
        trackers.trackUserData();
        logout().then((result) => {
            update([], undefined);
            axios.post(ApiUrl_Login_Logout).then(() => {
               
                //trackers.trackVirtualPageView();
            }).finally(() => {
                if (!result)
                    window.location.href = `/${lng}/`;
            });            
        });
    }

    const newOrderUrl = `/${lng}/orders/edit/`;
    const myProfileUrl = `/${lng}/users/edit/${rootModel?.CurrentUserProfile.Key}/`;
    const mySettingsUrl = `/${lng}/users/settings/${rootModel?.CurrentUserProfile.Key}/`;
    const loggedInTemplate = (<>
        <div className="dropdown text-start">
            <a href="#" className="d-flex gap-2 align-items-center link-dark text-decoration-none dropdown-toggle"
               id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                <UserInitialsComponent fullName={rootModel?.CurrentUserProfile.FullName}/>
                <div className={styles.userInfo}>
                    <div className={styles.userName}>{rootModel?.CurrentUserProfile.FullName}</div>
                    <div className={styles.userCompany}>{rootModel?.CurrentUserProfile.CompanyName}</div>
                </div>
            </a>
            <ul className={`dropdown-menu text-small`} aria-labelledby="dropdownUser1">
                <li><Link className="dropdown-item" to={newOrderUrl}>{t("ORDER_NEW_ORDER")}</Link></li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li><Link className="dropdown-item" to={myProfileUrl}>{t("USER_Profile")}</Link></li>
                <li><Link className="dropdown-item" to={mySettingsUrl}>{t("USER_Settings")}</Link></li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li><a className="dropdown-item" href="#" onClick={logoutMemberAsync}>{t("LOGIN_SIGN_OUT")}</a></li>
            </ul>
        </div>
    </>)
    return (
        <div className={styles.userInfoWrapper}>
            {rootModel
                ? loggedInTemplate
                : (<a href={`/${lng}/login`}>{t("LOGIN_SIGN_IN")}</a>)}
        </div>
    )
}

